import { TableLazyLoadEvent } from "primeng/table";
import { FiltersLazyLoadEvent, SpecificationQueryParamsEventModel } from "@irian-ro/abstract-resource";

export const mapTableEventToSpecificationEventModel = (lazyLoadMeta: TableLazyLoadEvent): SpecificationQueryParamsEventModel => {
  const convertedMultiSortMeta = lazyLoadMeta.multiSortMeta?.map(({ field, order }) => ({ field, order })) || [];

  const convertedFilters: FiltersLazyLoadEvent = Object.fromEntries(
    Object.entries(lazyLoadMeta.filters || {})?.map(([key, filter]) => [
      key,
      Array.isArray(filter)
        ? filter.map(({ value, matchMode }) => ({ value, matchMode }))?.reduce((acc, { value, matchMode }) => ({ ...acc, [value]: { value, matchMode } }), {})
        : filter ? { value: filter.value, matchMode: filter.matchMode } : undefined
    ])
  );

  return {
    first: lazyLoadMeta.first ?? undefined,
    rows: lazyLoadMeta.rows ?? undefined,
    sortField: lazyLoadMeta.sortField ?? undefined,
    sortOrder: lazyLoadMeta.sortOrder ?? undefined,
    multiSortMeta: convertedMultiSortMeta.length ? convertedMultiSortMeta : undefined,
    filters: Object.keys(convertedFilters).length ? convertedFilters : undefined,
    globalFilter: lazyLoadMeta.globalFilter ?? undefined
  };
}

